import {Component, OnInit} from '@angular/core';
import {Inspection} from "../../../classes/inspection";
import {Pa} from "../../../classes/pa";
import {Contract} from "../../../classes/contract";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {InspectionService} from "../../../services/inspection";
import {PaService} from "../../../services/pa";
import {ContractService} from "../../../services/contract";
import {mergeMap, switchMap, tap} from "rxjs/operators";
import {from} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
    selector: 'app-inspection-update',
    templateUrl: './inspection-update.component.html',
    styleUrls: ['./inspection-update.component.css']
})
export class InspectionUpdateComponent implements OnInit {

    inspection = new Inspection();
    inspectionUpdateResult = true;

    pas: Array<Pa> = [];
    contracts: Array<Contract> = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private modalService: NgbModal,
                private inspectionService: InspectionService,
                private paService: PaService,
                private contractService: ContractService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.inspectionService.getByID(params.get('id'))
                .subscribe({
                    next: (inspection: any) => {
                        this.inspection = inspection;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });

        this.paService.getAll()
            .pipe(
                switchMap((pasData: any) => from(pasData))
            )
            .subscribe({
                next: (pa: any) => {
                    this.pas.push(pa);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });

        this.contractService.getAll()
            .pipe(
                switchMap((contractsData: any) => from(contractsData))
            )
            .subscribe({
                next: (contract: any) => {
                    this.contracts.push(contract);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });
    }

    onPAChange() {
        if (this.inspection.fk_id_pa !== -1) {
            this.inspection.pa = this.pas.find((pa: Pa) => {
                return pa.id_pa === this.inspection.fk_id_pa;
            })!;
        } else {
            this.inspection.pa = new Pa();
        }
    }

    onSubmit() {
        this.paService.upsert(this.inspection.pa)
            .pipe(
                tap((pa: any) => this.inspection.fk_id_pa = pa.id_pa),
                mergeMap(() => this.inspectionService.update(this.inspection))
            )
            .subscribe({
                next: () => {
                    this.router.navigate(['/inspection/' + this.inspection.id_inspection]);
                },
                error: (err: HttpErrorResponse) => {
                    this.inspectionUpdateResult = false;
                    console.log(err);
                }
            });
    }

}
